// 保密柜取件--自定义数字键盘
<template>
  <div class="PrivacyCabinetPickUp">
    <div class="title">{{title}}</div>
    <div class="isPickUp"  v-if="isPickUp == 'success'">
      <i class="el-icon-success"></i>
      <p class="text">箱门已打开</p>
      <p class="text">请取走物品并随手关门</p>
    </div>
    <div v-else>
      <div class="lable">请输入取件密码</div>
      <div class="password-wrapper">
        <div class="box" @click="showKeyboard">
          <span class="grid" v-for="(item, index)  in passwordArr" :key="index">{{item}}</span>
        </div>
      </div>
      <!-- 取件说明 -->
      <div class="explain">
        <p class="explain-title">取件说明：</p>
        <p class="text">
          <span class="num">1. </span>
          <span class="t">请输入短信上的6位取件码</span>
        </p>
        <p class="text">
          <span class="num">2. </span>
          <span class="t">打开箱子后请及时取走物品并随手关闭箱门</span>
        </p>
        <p class="text">
          <span class="num">3. </span>
          <span class="t">属于以下情况，我司拥有免责的权利：因天灾、政治因素、工潮、天气或动荡而引致的延误、损失或破坏。投交时邮件封装完好，无拆动痕迹，且收件人已按规定手续签收，事后收件人发现内件有遗失或损毁的</span>
        </p>
        <p class="text">
          <span class="num">4. </span>
          <span class="t">以上内容最终解释权归本公司所有</span>
        </p>
      </div>

      <!-- 数字键盘 -->
      <CustomNumberKeyboard ref="keyboard" :isShow="isShow" @getInputValue="getInputValue" @deleteValue="deleteValue"></CustomNumberKeyboard>
    </div>
  </div>
</template>
<script>
import CustomNumberKeyboard from './CustomNumberKeyboard'
import { showToast, showLoading, hideLoading } from '../../../../static/js/utility/utility';
import axios from 'axios'
import * as config from '../../../../static/js/config.js';

export default {
  name:'PrivacyCabinetPickUp',
  data(){
    return {
      title: '取件',
      isPickUp: 'no',
      password: '',
      passwordArr: ['', '', '', '', '', ''],
      // 是否显示数字键盘
      isShow: false
    }
  },
  components:{
    CustomNumberKeyboard
  },
  created(){
    // console.log('tag', this.$route)
  },
  mounted(){
  },
  methods:{
    // 显示键盘
    showKeyboard () {
      this.$refs.keyboard.switchShow()
    },
    // 接收子组件输入的值
    getInputValue (num) {
      this.password += num
    },
    // 删除
    deleteValue () {
      this.password = this.password.substr(0, this.password.length-1)
    },
    post (url, data) {
      return new Promise(function (resolve, reject) {
        axios({
          method: 'post',
          url: config.commonAddress + url,
          data: data
        })
        .then(function (res) {
          // console.log('res.data', res.data)
          resolve(res.data)
        })
        .catch(function (error) {
          utils.hideLoading()
          utils.showToast('连接服务器失败，取消操作请重试！')
          console.log('error', error)
          reject(error)
        })
      })
    },
    // 取件
    async pickUp () {
      let vm = this
      let data = {
        open_password: vm.password,
        device_no_id: vm.$route.query.device_no_id
      }
      console.log('data::', data)
      showLoading('开门中')
      let res = await vm.post('/Web/Secrecy/fetchByOpenPassword', data)
      hideLoading()
      this.$refs.keyboard.switchShow()
      if (res.meta.code == 200) {
        // 取件成功
        this.isPickUp = 'success'
        this.title = '取件成功'
      } else {
        // 取件失败
        // showToast('取件密码错误')
        showToast(res.meta.message)
        this.password = ''
        this.isPickUp = 'fail'
      }
    }
  },
  watch:{
    // 监听密码输入
    'password'(newVal, oldVal) {
      // console.log('oldVal', oldVal)
      console.log('newVal', newVal)
      let arr = [...this.password.split('')]
      arr.forEach((item, index) => {
        this.$set(this.passwordArr, index, item)
      })
      for (var i = arr.length; i < 6; i++) {        
        this.$set(this.passwordArr, i, '')
      }
      // console.log('passwordArr', this.passwordArr)
      // 当6位密码输完，自动取件
      if (this.password.length == 6) {
        this.pickUp()
      }
    }
  }
}
</script>

<style lang="scss">
.PrivacyCabinetPickUp{
  width: 100%;
  color: #333333;
  background-color: #ffffff;
  .title {
    width: 100%;
    height: 0.88rem;
    line-height: 0.88rem;
    font-size: 0.34rem;
    text-align: center;
    color: #ffffff;
    background-color: #2d83f3;
  }
  .lable {
    font-size: 0.28rem;
    margin-top: 0.2rem;
    text-indent: 0.2rem;
  }
  .password-wrapper {
    width: 5.12rem;
    margin: 0.4rem auto;
    position: relative;
    .box {
      display: flex;
      justify-content: center;
      .grid.fail {
        background-color: #e3fbe3;
      }
      .grid {
        width: 0.72rem;
        height: 0.72rem;
        line-height: 0.72rem;
        text-align: center;
        font-size: 0.3rem;
        font-weight: bold;
        margin-right: 0.16rem;
        border: 1px solid #b3b3b3;
      }
      .grid:last-child {
        margin-right: 0;
      }
    }
    .input {
      width: 100%;
      height: 100%;
      opacity: 0;
      color: transparent;
      caret-color: transparent;
      // background-color: #cccccc;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .explain {
    width: 100%;
    padding: 0 0.3rem;
    font-size: 0.2rem;
    line-height: 0.36rem;
    .text {
      padding-left: 0.3rem;
      display: flex;
      .num {
        margin-right: 0.1rem;
      }
    }
  }

  // 取件成功
  .isPickUp {
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-icon-success {
      font-size: 1.2rem;
      color: #04BE02;
      margin: 1.6rem 0 0.2rem;
    }
    .text {
      font-size: 0.24rem;
      line-height: 0.36rem;
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/PhonePage/PrivacyCabinet/PickUp.vue